import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Switch as MaterialSwitch } from '@material-ui/core';

import styles from './Switch.css';


class Switch extends Component {
  static propTypes = {
    classes: PropTypes.object,
    wrapperClassName: PropTypes.string,
  };

  static defaultProps = {
    classes: {},
    wrapperClassName: undefined,
  };

  render() {
    const { classes, wrapperClassName, ...restProps } = this.props;

    const applyClasses = {
      root: styles.root,
      track: styles.track,
      checked: styles.checked,
      thumb: styles.thumb,
      ...classes,
    };

    const wrapperClasses = classNames(styles.wrapper, wrapperClassName);

    return (
      <div className={wrapperClasses}>
        <MaterialSwitch
          classes={applyClasses}
          disableRipple={true}
          {...restProps}
        />
      </div>
    );
  }
}

export default Switch;
